import(/* webpackChunkName: "fundation-init" */'./index');
